import { Button } from '@breetometer/components';
import { closeModal, useAppDispatch } from 'BreetRedux';
import { useCallback } from 'react';

import type { IFilePreviewCTA } from '../../FileInput/FileInput.helpers';

export const FilePreviewCTA = ({ inputFileSelectorId, modalId }: IFilePreviewCTA) => {
	const dispatch = useAppDispatch();

	const onReplace = useCallback(() => {
		const input = document.getElementById(inputFileSelectorId) as HTMLInputElement;
		input.click();
	}, [inputFileSelectorId]);

	const onClose = useCallback(() => {
		dispatch(closeModal(modalId));
	}, [dispatch, modalId]);

	return (
		<div className='file-preview-wrapper_cta'>
			<Button
				label='Replace'
				onClick={onReplace}
			/>
			<Button
				label='Done'
				onClick={onClose}
				variant='outline'
				className='border-dark-navy color-primary-50'
			/>
		</div>
	);
};
